package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.px

val CompetenceFormContainerStyle = CssStyle {
    base {
        Modifier.gap(15.px)
    }

    Breakpoint.MD {
        Modifier.gap(25.px)
    }
}

/**
 * Largeur du champ texte Compétence.
 * Mobile : 340px
 * MD et supérieur : 770px
 */
val CompetenceFieldStyle = CssStyle {
    base {
        Modifier.width(340.px)
    }

    Breakpoint.MD {
        Modifier.width(770.px)
    }
}

/**
 * Taille du libellé "Niveau".
 */
val CompetenceLabelTextStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }

    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
}

/**
 * Slider de niveau.
 * Mobile : 240px
 * MD et supérieur : 500px
 */
val CompetenceRangeInputStyle = CssStyle {
    base {
        Modifier
            .width(240.px)
            .styleModifier {
                property("height", "10px")
                property("cursor", "pointer")
                property("accent-color", Colors.LighterBlue.toString())
                property("outline", "none")
            }
    }

    Breakpoint.MD {
        Modifier.width(500.px)
    }
}

/**
 * Taille du texte de valeur
 * ("Débutant", "Expert", etc.).
 */
val CompetenceValueTextStyle = CssStyle {
    base {
        Modifier.fontSize(14.px)
    }

    Breakpoint.MD {
        Modifier.fontSize(18.px)
    }
}